var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.27,
    height: 15.853,
    viewBox: "0 0 14.27 15.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58342",
    "data-name": "Group 58342",
    transform: "translate(-2.998 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42255",
    "data-name": "Path 42255",
    d: "M10.134,2a.793.793,0,0,1,.793.793V10.72a.793.793,0,0,1-1.585,0V2.793A.793.793,0,0,1,10.134,2ZM7.65,4.83a.793.793,0,0,1-.29,1.083,5.549,5.549,0,1,0,5.548,0A.793.793,0,0,1,13.7,4.541a7.134,7.134,0,1,1-7.135,0,.793.793,0,0,1,1.084.289Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.c5b610e05fb5893605b4796072399d4e.svg";
export { ForwardRef as ReactComponent };